import _ from 'lodash';
import { vault } from '../../actions/actionTypes';
export const initialState = {};
export default function (state = initialState, action) {
    switch (action.type) {
        case vault.FETCH_FILES:
            const fetchFilesPayload = action.payload;
            if (fetchFilesPayload.firstFetch) {
                return { ..._.mapKeys(fetchFilesPayload.files, 'uriKey') };
            }
            return { ...state, ..._.mapKeys(fetchFilesPayload.files, 'uriKey') };
        case vault.DELETE_FILE:
            const deleteFilePayload = action.payload;
            const newState = { ...state };
            delete newState[deleteFilePayload.uriKey];
            return newState;
        case vault.LOGOUT_FILES:
            return initialState;
        default:
            return state;
    }
}
